var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationRoad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69881 7.23155C1.21069 7.23155 0 8.44224 0 9.93039C0 10.6827 0.411365 11.5914 1.2227 12.6312C1.80218 13.3738 2.37486 13.9109 2.39897 13.9334L2.69884 14.2134L2.99872 13.9334C3.02283 13.9109 3.59551 13.3738 4.17499 12.6312C4.98629 11.5914 5.39769 10.6827 5.39769 9.93039C5.39766 8.44224 4.18697 7.23155 2.69881 7.23155ZM2.69881 10.8035C2.21738 10.8035 1.8257 10.4118 1.8257 9.93039C1.8257 9.44896 2.21738 9.05728 2.69881 9.05728C3.18025 9.05728 3.57193 9.44896 3.57193 9.93039C3.57193 10.4118 3.18025 10.8035 2.69881 10.8035Z",
    fill: "#F11158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3014 0.786636C10.8132 0.786636 9.60254 1.99732 9.60254 3.48545C9.60254 4.23779 10.0139 5.14646 10.8252 6.18625C11.4047 6.9289 11.9774 7.46593 12.0014 7.48843L12.3013 7.76841L12.6012 7.48843C12.6253 7.46593 13.198 6.9289 13.7774 6.18625C14.5888 5.14646 15.0001 4.23779 15.0001 3.48545C15.0002 1.99735 13.7895 0.786636 12.3014 0.786636ZM12.3014 4.35859C11.8199 4.35859 11.4282 3.96691 11.4282 3.48548C11.4282 3.00404 11.8199 2.61237 12.3014 2.61237C12.7828 2.61237 13.1745 3.00404 13.1745 3.48548C13.1745 3.96691 12.7828 4.35859 12.3014 4.35859Z",
    fill: "#F11158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6895 14.0516H4.45605V13.1728H10.6895C11.3356 13.1728 11.8613 12.6471 11.8613 12.001C11.8613 11.3548 11.3356 10.8292 10.6895 10.8292H8.23189C7.10117 10.8292 6.18125 9.90928 6.18125 8.77856C6.18125 7.64785 7.10117 6.72795 8.23189 6.72795H10.543V7.60675H8.23189C7.58571 7.60675 7.06005 8.13241 7.06005 8.77856C7.06005 9.42471 7.58571 9.95038 8.23189 9.95038H10.6895C11.8202 9.95038 12.7401 10.8703 12.7401 12.001C12.7401 13.1317 11.8202 14.0516 10.6895 14.0516Z",
    fill: "#F11158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationRoad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-road.e8015d457cc16f583bf0828edcd898bb.svg";